/**
 * AudioManager for PWA
 * Manages low-latency playback of minimalist Chinese-inspired micro-sounds.
 */

const getPublicPath = (path) => {
  // Handles potential subfolder hosting
  const publicUrl = process.env.PUBLIC_URL || '';
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${publicUrl}${cleanPath}`;
};

const sounds = {
  tap: getPublicPath('/sounds/muyu_click.mp3'),
  flip: getPublicPath('/sounds/muyu_click.mp3'),
  success: getPublicPath('/sounds/chime_soft.mp3'),
  transition: getPublicPath('/sounds/muyu_click.mp3'),
};

const audioCache = {};

// Preload sounds
Object.entries(sounds).forEach(([name, path]) => {
  try {
    const audio = new Audio(path);
    audio.load();
    audioCache[name] = audio;
  } catch (err) {
    console.error(`[AudioEngine] Failed to preload sound: ${name}`, err);
  }
});

export const playSound = (soundName) => {
  const audio = audioCache[soundName];
  if (!audio) {
    console.warn(`Sound "${soundName}" not loaded or not found`);
    return;
  }

  // Reset and play
  audio.currentTime = 0;
  audio.play().catch(err => {
    // Browsers often block auto-play until user interaction
    console.log(`Audio playback failed for "${soundName}":`, err.message);
  });
};

export const vibrate = (duration = 15) => {
  if (navigator.vibrate) {
    navigator.vibrate(duration);
  }
};

export const SOUNDS = {
  TAP: 'tap',
  FLIP: 'flip',
  SUCCESS: 'success',
  TRANSITION: 'transition',
};

